<template>
  <CloseCircleButtonModal
    :title-text="titleText"
    @clicked-modal-cover="closeModal"
    @clicked-close="closeModal"
  >
    <p class="campaign-attention-modal__attention-text">
      {{ attention }}
    </p>
  </CloseCircleButtonModal>
</template>

<script>
import CloseCircleButtonModal from '../../../molecules/modals/CloseCircleButtonModal.vue'

export default {
  name: 'CampaignAttentionModal',
  components: {
    CloseCircleButtonModal
  },
  props: {
    titleText: {
      type: String,
      required: true
    },
    attention: {
      type: String,
      required: true
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden'
  },
  beforeUnmount() {
    document.body.style.overflow = ''
  },
  methods: {
    closeModal() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.campaign-attention-modal {
  &__attention-text {
    @extend %caption;
    color: $gray-1;
    margin: 0;
    white-space: pre-wrap;
  }
}
</style>
